export default "__VITE_ASSET__CVWk9wuT__"